<template>
  <div>
    <AssetHero />
  </div>
</template>

<script>
import AssetHero from "@/components/AssetHero.vue";
export default {
  components: {
    AssetHero
  }
};
</script>

<style lang="scss" scoped></style>
